export default "__VITE_ASSET__99996218__"